/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgPolicy48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M7.002 5.066l-3-.066v35.5l27 .066v-3.957h-23.5l-.5-31.543z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M38.002 2.79a.751.751 0 00-.75-.75h-29.5a.751.751 0 00-.75.75v33.5a.751.751 0 00.75.75h29.5a.751.751 0 00.75-.75V2.79z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M7.002 5.065H4.529a.75.75 0 00-.75.75V40c0 .414.336.75.75.75h29.473'
      />
      <path
        stroke='currentColor'
        strokeLinejoin='round'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M12 23h15M12 27.023h12.5M12 31h7.5'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M18.498 16.085h6a1 1 0 001-1v-1.5a1 1 0 00-1-1h-4.572a1 1 0 01-1-1v-1.5a1 1 0 011-1h5.572M22.002 15.585v2.5M22.002 7v2.585'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M38.01 45s-6.762-2.5-6.762-7v-8.471c3.25 0 4.571.439 6.738-1.029h.024c2.166 1.468 3.488 1.029 6.738 1.029V38c0 4.5-6.738 7-6.738 7z'
      />
      <path
        stroke='currentColor'
        strokeLinejoin='round'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M34.775 36.577L37.1 38.99a.011.011 0 00.01.003.013.013 0 00.009-.005l4.379-5.489'
      />
    </svg>
  );
}

export default SvgPolicy48;
